<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="960px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-row :gutter="12">
        <el-col :span="10">
          <el-form-item
            label="服务产品："
            prop="serviceCategoryName">
            <el-input v-model="info.serviceCategoryName"></el-input>
          </el-form-item>
          <el-form-item
            v-if="parent && parent.associateIndustryCategory === 1"
            label="行业管理："
            prop="level2Categorys">
            <category-select v-model="info.level2Categorys"></category-select>
          </el-form-item>
          <el-form-item
            label="联系方式："
            prop="contactInfo">
            <el-input v-model="info.contactInfo"></el-input>
          </el-form-item>
          <el-form-item
            label="图片："
            prop="serviceCategoryImage">
            <upload-with-crop
              v-model="info.serviceCategoryImage"
              cropper
              :isLt2M="500"
              :fixedNumber="[58,27]"
              :autoCropWidth="290"
              :autoCropHeight="135"></upload-with-crop>
          </el-form-item>
          <!-- <template > -->
          <el-form-item
            label="描述："
            prop="features">
            <el-input
              v-model="info.features"
              type="textarea"
              :rows="4"
              :autosize="{ minRows: 2, maxRows: 6}"></el-input>
          </el-form-item>
          <el-form-item
            v-if="parent && parent.needConfigPackage === 0"
            label="周期："
            prop="cycleDays">
            <el-input-number
              v-model="info.cycleDays"
              :precision="0"
              :min="0"></el-input-number>天
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item
            label="图文详情："
            prop="images">
            <desc-images
              v-model="info.images"
              edit></desc-images>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- </template> -->
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit"> 确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CategorySelect from '../../components/category-select.vue'
import DescImages from '../../components/public/desc-images.vue'
import UploadWithCrop from '../../components/public/upload-with-crop.vue'
export default {
  name: 'EditServiceModal',
  components: { CategorySelect, UploadWithCrop, DescImages },
  props: {
    callback: { type: Function }
  },
  data() {
    return {
      loading: false,
      visible: false,
      parent: null,
      info: { serviceId: null, serviceCategoryId: null, serviceCategoryName: '', level2Categorys: [], features: '', cycleDays: null, serviceCategoryImage: [], contactInfo: '', images: [] },
      rules: {
        serviceCategoryName: [
          { required: true, message: '请输入服务产品名称', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ],
        features: [
          { required: true, message: '请输入描述', trigger: 'blur' },
          { max: 200, message: '长度最多 200 个字符', trigger: 'blur' }
        ],
        cycleDays: [{ required: false, message: '请输入服务周期', trigger: 'blur' }],
        level2Categorys: [{ required: true, message: '请选择行业管理', trigger: 'blur' }],
        serviceCategoryImage: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        contactInfo: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        images: [{ required: true, message: '请上传图文信息', trigger: 'change' }]
      }
    }
  },
  computed: {
    title() {
      const serviceCategoryId = this.info.serviceCategoryId
      return (serviceCategoryId ? '编辑' : '新增') + '服务产品'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.parent = null
      this.info = { ...this.info, ...this.$options.data().info }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.serviceCategoryId ? 'updateservicecategory' : 'addservicecategory'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info,
              cycleDays: this.info.cycleDays || 0,
              level2Categorys: this.info.level2Categorys.map(i => { return { classId: i[1] } }),
              serviceCategoryImage: this.info.serviceCategoryImage.map(i => i.url).join(','),
              images: this.info.images.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              console.log(this.info.serviceId)
              this.$message.success(this.title + '成功')
              this.callback && this.callback(this.info.serviceId)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add(options = {}) {
      this.parent = options
      this.info.serviceId = options.serviceId
      this.toggleModal(true)
    },
    update(options = {}, parent) {
      this.info = {
        ...this.info,
        ...options,
        level2Categorys: (options.level2Categorys || []).map(i => { return [i.parent, i.classId] })
      }
      this.parent = parent
      this.toggleModal(true)
    }
  }
}
</script>
